import React from "react";
import DataTable from "../../../components/DataTable";

const Faculties = () => (
  <DataTable
    title="Faculties"
    apiPath="/api/admin/master/faculties"
    columns={[
      { key: "id", label: "ID" },
      { key: "name", label: "Name" },
    ]}
    formFields={[
      { key: "name", label: "Faculty Name", required: true },
    ]}
  />
);

export default Faculties;
